import Vue from 'vue'
import Vuex from 'vuex'
import { mainLangValues } from '../plugins/language.js'
import { commonValues } from '../plugins/common-lang.js'
import { popupValues } from '../plugins/popup-lang.js'
import { errorCodes } from '../plugins/error-code.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        preRegForm: {
            infoColor: '',
            infoText: '',
            infoSetting: false,
        },
        lang: '',
        evtApiServer: process.env.VUE_APP_API_SERVER,
        evtBase: {},
        isLiveServer: process.env.VUE_APP_IS_LIVE,
        langValues: Object.assign({}, mainLangValues, popupValues, commonValues, errorCodes),        
        isPreRegOpen: false,
        iframeDialog: false,
        returnSrc: undefined,
        siteOpen: false
  },
    getters: {
        getLangValue: (state) => (transCode) => {
            let lang = state.langValues[transCode]
            if (lang) {
                return lang[state.lang]?.replace('\n', '<br/>') ?? `Not found text Key/Lang=>(${transCode}/${state.lang})`
            }
            else {
                return `Not found text Key=>(${transCode})`
            }
        },
  },
    mutations: {

  },
    actions: {
        
  },
  modules: {
  }
})
